import React, { Component } from 'react';
import CardSimple from 'screens/components/basic/CardSimple';

const PaymentTaxes = () => {
    return (
        <div id="payment-tax-pay">
            <br />
            <div>
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>Payment</h2>
                        <p>Here you can check the total amount paid with the different ways to pay your store has active.</p>
                        <p>To Edit:</p>
                        <ul>
                            <li>Go to Menu {`>`} Preferences {`>`} Payment</li>
                            <li>Find the Payment Method you want to edit. Click the Edit button</li>
                            <li>Change the necessary information. Click on Save</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="payment-tax-tax">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>Taxes</h2>
                        <p>TechPOS has already integrated the Provincial and Government Taxes. If you need to edit a certain tax</p>
                        <ul>
                            <li>Go to Menu {`>`} Preferences {`>`} Taxes</li>
                            <li>Locate the tax you want to Edit. Click the Edit button</li>
                            <li>Make the necessary changes. Click on Save.</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
        </div>
    )
}

export default PaymentTaxes;